export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbiorca: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Użytkownik nie znaleziony"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakty"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szczegóły"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybór użytkowników"])}
}